var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"m-2"},[_vm._v(" Copyright 2022 © "),_c('a',{attrs:{"href":"https://manageo.io/?utm_source=ice&utm_medium=ice&utm_campaign=ice"}},[_vm._v("Manageo.io")])])])])])
}]

export { render, staticRenderFns }